import React from 'react'
import PropTypes from 'prop-types'

import { CustomerSyncExplanation } from 'components/CustomerSyncExplanation'
import { Button, Grid, Popup } from 'semantic-ui-react'

export default function IntercomContactSyncIntegrationV2({
  syncButtonLoading,
  isAuthenticated,
  isContactSyncEnabled,
  toggleCustomersSync,
}) {
  return (
    <React.Fragment>
      <Grid stackable>
        <Grid.Column width={8} wide>
          <CustomerSyncExplanation
            integration="Intercom"
            helpCenterLink="https://help.simplesat.io/en/articles/5230032-intercom-integration#h_ee78f1f8eb"
          />
          <ToggleIntercomContactSyncButton
            isAuthenticated={isAuthenticated}
            syncButtonLoading={syncButtonLoading}
            isContactSyncEnabled={isContactSyncEnabled}
            toggleCustomersSync={toggleCustomersSync}
          />
          <p className="mt-6">
            <em>
              After an initial one-time import, Simplesat will check for any new or changed contacts
              every 24 hours.
            </em>
          </p>
        </Grid.Column>
        <Grid.Column width={8} wide>
          <img
            src="https://cdn.simplesat.io/intercom/sync-intercom-contacts.png"
            alt="Sync Intercom contacts"
            className="ui bordered image float-right"
          />
        </Grid.Column>
      </Grid>
    </React.Fragment>
  )
}

IntercomContactSyncIntegrationV2.propTypes = {
  syncButtonLoading: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isContactSyncEnabled: PropTypes.bool,
  toggleCustomersSync: PropTypes.func.isRequired,
}

export function ToggleIntercomContactSyncButton({
  isAuthenticated,
  syncButtonLoading,
  isContactSyncEnabled,
  toggleCustomersSync,
}) {
  if (!isAuthenticated) {
    return (
      <Popup
        basic
        trigger={
          <div>
            <Button primary disabled>
              Activate integration
            </Button>
          </div>
        }
      >
        You need to authenticate with Intercom before enabling any integrations.
      </Popup>
    )
  }

  if (!isContactSyncEnabled) {
    return (
      <Button
        primary
        loading={syncButtonLoading}
        disabled={syncButtonLoading}
        onClick={toggleCustomersSync}
      >
        Activate integration
      </Button>
    )
  }

  return (
    <Button loading={syncButtonLoading} disabled={syncButtonLoading} onClick={toggleCustomersSync}>
      Deactivate integration
    </Button>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/IntercomContactSyncIntegrationV2/index.js